<template>
  <div class="col-md-12">
    <div class="card card-container">
      <h4><font-awesome-icon icon="plus-square" /> Add User</h4>
      <form name="form" @submit.prevent="saveUser">
        <div v-if="!successful">
          <div class="form-group">
            <label for="staffNo">Staff No.:</label>
            <input v-model="user.staffNo" v-validate="'required|max:75'" type="text" class="form-control" name="staffNo"/>
            <div v-if="submitted && errors.has('staffNo')" class="alert-danger">{{errors.first('staffNo')}}</div>
          </div>
          <div class="form-group">
            <label for="firstName">First Name:</label>
            <input v-model="user.firstName" v-validate="'required|max:75'" type="text" class="form-control" name="firstName"/>
            <div v-if="submitted && errors.has('firstName')" class="alert-danger" >{{errors.first('firstName')}}</div>
          </div>
          <div class="form-group">
            <label for="lastName">Last Name:</label>
            <input v-model="user.lastName" v-validate="'required|max:75'" type="text" class="form-control" name="lastName"/>
            <div v-if="submitted && errors.has('lastName')" class="alert-danger" >{{errors.first('lastName')}}</div>
          </div>
          <div class="form-group">
            <label for="username">Username:</label>
            <input v-model="user.username" v-validate="'required|min:3|max:20'" type="text" class="form-control" name="username"/>
            <div v-if="submitted && errors.has('username')" class="alert-danger">{{errors.first('username')}}</div>
          </div>
          <div class="form-group">
            <label for="email">Email:</label>
            <input v-model="user.email" v-validate="'required|email|max:50'" type="email" class="form-control" name="email"/>
            <div v-if="submitted && errors.has('email')" class="alert-danger">{{errors.first('email')}}</div>
          </div>
          <div class="form-group">
            <label for="password">Password:</label>
            <input v-model="user.password" v-validate="'required|min:6|max:40'" type="password" class="form-control" name="password"/>
            <div v-if="submitted && errors.has('password')" class="alert-danger">{{errors.first('password')}}</div>
          </div>
          <div class="form-group">
            <label for="types">Select User Type:</label>
            <select v-model="user.userType" v-validate="'required|min:3|max:30'" class="form-control" name="userType">
              <option v-for="type in types" v-bind:value="type.code" :key="type.code">{{ type.name }}</option>
            </select>
            <div v-if="submitted && errors.has('types')" class="alert-danger">{{errors.first('types')}}</div>
          </div>
          <div class="form-group">
            <button type="submit" class="m-3 btn btn-sm btn-success"><font-awesome-icon icon="save" /> Save</button>
            <button class="m-3 btn btn-sm btn-primary" @click="usersList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
          </div>
        </div>
      </form>

      <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
        {{message}}
      </div>
      <div v-if="message && successful">
        <button class="btn btn-primary" @click="newUser"><font-awesome-icon icon="plus" /> Add User</button>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../services/user.service";
import User from '../models/user';

export default {
  name: 'add-user',
  data() {
    return {
      /*user: {
        id: null,
        staffNo: '',
        firstName: '',
        lastName: '',
        username: '',
        email: '',
        password: '',
        userType: '',
        active: true
      },*/
      user: new User('', '', '', '', '', '', ''),
      submitted: false,
      successful: false,
      message: '',
      types: [
         { code: 'entry', name: 'Data Entry' },
         { code: 'man', name: 'Manager' },
         { code: 'aud', name: 'Auditor' },
         { code: 'admin', name: 'Admin' },
         { code: 'super', name: 'Super Admin' }
      ],
      typeSet: new Set(),
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  methods: {
    saveUser() {
      /*var userData = {
        staffNo: this.user.staffNo,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        username: this.user.username,
        email: this.user.email,
        password: this.user.password,
        userType: this.user.userType
      };*/
      this.message = '';
      this.submitted = true;
      this.$validator.validate().then(isValid => {
        if (isValid) {
          UserService.create(this.user).then(
            response => {
              this.message = response.data.message;
              console.log('data: '+response.data);
              console.log('data message: '+response.data.message);
              this.submitted = true;
              this.successful = true;
            },
            error => {
              this.message = (error.response && error.response.data) || error.message || error.toString();
              this.successful = false;
            })
            .catch(e => {
              console.log('e: '+e);
              this.message = e.message;
              console.log('e message: '+e.message);
            });
        }
      });
    },

    newUser() {
      this.submitted = false;
      this.successful = false;
      this.message = '';
      this.user = {};
    },
    
    usersList() {
      this.$router.push('/users');
    }
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
  font-size: 1.2em;
  text-align: left;
}

.card-container.card {
  max-width: 750px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>